import { Capacitor } from '@capacitor/core';
import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import type { FirebaseWebConfig } from '@/models/PageConfig';

let appInstance: FirebaseApp | null = null;

export function initFirebaseWeb(config: FirebaseWebConfig | undefined): FirebaseApp | null {
  if (Capacitor.isNativePlatform()) return null;
  if (!config?.ApiKey) return null;
  if (appInstance) return appInstance;
  const existing = getApps();
  if (existing.length > 0) {
    appInstance = existing[0] ?? null;
    return appInstance;
  }
  appInstance = initializeApp({
    apiKey: config.ApiKey,
    authDomain: config.AuthDomain,
    projectId: config.ProjectId,
    storageBucket: config.StorageBucket,
    messagingSenderId: config.MessagingSenderId,
    appId: config.AppId,
    measurementId: config.MeasurementId,
  });
  return appInstance;
}

export function isFirebaseWebReady(): boolean {
  if (Capacitor.isNativePlatform()) return true;
  return getApps().length > 0;
}

export async function preloadFirebaseAuthPlugin(): Promise<void> {
  if (Capacitor.isNativePlatform() || !isFirebaseWebReady()) return;
  await import('@capacitor-firebase/authentication');
}
